/**
 * Fallback handler: mic-permission-denied
 *
 * Fires when the browser raises NotAllowedError from getUserMedia —
 * the user explicitly denied mic access (or the OS blocks it).
 * A retry action is provided so the user can re-prompt.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeMicPermissionDeniedBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "mic-permission-denied",
    message:
      "Microphone access was denied. Grant permission in your browser settings and try again.",
    retryAction: onRetry,
    retryLabel: "Try again",
  };
}
